import { isAfter } from 'date-fns';

const handleAfterTicketSaleEndsScheduled = ({ entity, entityKey, allEntities, now }) => {
  if (!entity[entityKey]) {
    return { isScheduled: false, hasInvalidReference: false };
  }

  const referencedEntity = allEntities.find(e => e._id === entity[entityKey]);
  if (!referencedEntity) {
    return { isScheduled: false, hasInvalidReference: true };
  }

  if (referencedEntity.status !== 'enabled') {
    return { isScheduled: false, hasInvalidReference: true };
  }

  const saleStartOn = referencedEntity.saleEndOn ? new Date(referencedEntity.saleEndOn) : null;

  if (saleStartOn == null) {
    return { isScheduled: false, hasInvalidReference: true };
  }

  return { isScheduled: isAfter(saleStartOn, now), hasInvalidReference: false };
};

export default handleAfterTicketSaleEndsScheduled;
